// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_41-0";
export var eligibilityCardNotEligible = "_41-1";